import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/common';
import classNames from 'classnames';
import { TendersVars } from 'src/models/procurements/Tenders/types';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import styles from './index.module.scss';

type Props = {
  filters: (keyof TendersVars)[];
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
};
export const FilterClear: FC<Props> = ({ className, onClick, disabled, filters }) => {
  const { t } = useTranslation();
  const [{ vars, initVars }, updateVars] = useApiTenders();

  const varsDiff = useMemo(() => filters.filter(key => vars[key] !== initVars[key]), [filters, initVars, vars]);
  const isChanged = useMemo(() => !!varsDiff.length, [varsDiff.length]);
  const onClearAll = useCallback(() => {
    if (!!varsDiff.length) {
      const clearingVars: TendersVars = varsDiff.reduce((_vars, key) => ({ ..._vars, [key]: initVars[key] }), {});
      updateVars(clearingVars);
      onClick?.();
    }
  }, [initVars, onClick, updateVars, varsDiff]);

  return (
    <Button
      type={'link'}
      onClick={onClearAll}
      disabled={disabled ?? !isChanged}
      className={classNames(styles.button, className)}
    >
      {t('Common.clear')}
    </Button>
  );
};

export default FilterClear;
